<template>
    <div>
      <!--General Top Bar -->
      <!-- <general-top-bar :title="$t('reports.ocr')"></general-top-bar> -->
      <!--End General Top Bar -->
      <div class="col-md-12 card text-left">
        <div class="card-header"></div>
        <div class="report-filters">
          <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left date-range">
            <el-date-picker
              type="daterange"
              v-model="clients.valid"
              class="mid"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :name="pickerNames"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <div class="search-button-reports form-group pull-left">
            <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="getData(null)"><i class="ti-search"></i></div>
          </div>
          <div class="search-button-reports form-group pull-left">
            <div :title="$t('reports.export')" class="btn btn-icon btn-info btn-print" @click="exportData(null)"><i class="ti-file"></i></div>
          </div>
          <div class="search-button-reports form-group pull-left">
            <div :title="$t('reports.requestReport')" class="btn btn-icon btn-info" @click="requestReport()"><i class="ti-calendar"></i></div>
          </div>
        </div>
        <div class="card-content total-pagination pad-15">
          <data-tables-server
              class=""
              @query-change="paginationChanged"
              v-loading="loading"
              :data="clientsTableData"
              :search-def="{ show: false }"
              :total="totalClients"
              :pagination-props="paginationProps"
              :table-props="tableOptions"
              style="width: 100%;"
            >
            <el-table-column
              prop="user.id"
              label="Id user"
            ></el-table-column>
            <el-table-column :min-width="80" prop="name" label="Nume">
              <template slot-scope="props">
                {{ props.row.user.firstname }} {{ props.row.user.lastname }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="120"
              prop="bon_cif"
              label="CIF bon"
            ></el-table-column>
            <el-table-column
              :min-width="120"
              prop="bon_user"
              label="Utilizator bon"
            ></el-table-column>
            <el-table-column
              :min-width="120"
              prop="bon_data"
              label="Data bon"
            ></el-table-column>
            <el-table-column
              :min-width="120"
              prop="bon_nr"
              label="Nr bon"
            ></el-table-column>
            <el-table-column
              :min-width="120"
              prop="bon_total"
              label="Total bon"
            ></el-table-column>
            <el-table-column :min-width="80" prop="name" label="Puncte Primite">
              <template slot-scope="props">
                <span class="pad-lf-30">{{ props.row.gained_loyalty_points }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Data scanare">
              <template slot-scope="props">
                <span>{{ formatDateTime(props.row.created_at) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :width="120" 
              :label="$t('general.actions')">
              <template slot-scope="props">
                <a v-if="props.row.photo_url" class="btn btn-info btn-icon duplicate-prod" :href="props.row.photo_url" target="_blank">
                  <i class="ti-image"></i>
                </a>
              </template>
            </el-table-column>
            <!-- <el-table-column
              :min-width="120"
              prop="created_at"
              label="Data scanare"
            ></el-table-column> -->
            <!-- <el-table-column
              :min-width="60"
              prop="orders_count"
              label="Echivalent"
            >
              <template slot-scope="props">
                <b>{{ parseFloat(props.row.points_to_money).toFixed(2)}} {{ currency }}</b>
              </template>
            </el-table-column> -->
          </data-tables-server>
        </div>
      </div>
    </div>
</template>
<script>
  // import Vue from 'vue'
  import moment from 'moment'
  import {DatePicker} from 'element-ui'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'

  export default {
    components: {
      // GeneralTopBar,
      [DatePicker.name]: DatePicker
    },
    created () {
      this.getData()
    },
    data () {
      return {
        loading: false,
        currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
        clients: {
          'valid': [
            moment().date(1).format('YYYY-MM-DD'),
            moment().endOf('month').format('YYYY-MM-DD')
          ],
          searchClient: null,
          searchEmployee: null
        },
        paginationProps: {
          // pageSizes: [5, 10, 15],
          layout: 'prev, pager, next, sizes, total'
        },
        tableOptions: {
          defaultSort: {
            prop: 'name',
            order: 'ascending'
          }
        },
        labels: null,
        labelingPrimaryOption: null,
        totalClients: null,
        sortBy: 'name',
        sortOrder: 'asc',
        clientsTableData: [],
        pickerOptions: {
          disabledDate (date) {
            return date < moment().subtract(12, 'months').startOf('day')
          }
        },
        pickerNames: ['date_from', 'date_to']
      }
    },
    methods: {
      paginationChanged (query) {
        if (query.type === 'page') this.getData(query)
        if (query.type === 'size') this.getData(query)
        if (query.type === 'sort') {
          if (query.sort.order) {
            this.sortBy = query.sort.prop
            this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc'
          } else {
            this.sortBy = 'name'
            this.sortOrder = 'asc'
          }
          this.getData(query)
        }
      },
      getData (query) {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          start_date: this.clients.valid[0],
          end_date: this.clients.valid[1],
          search_client: this.clients.searchClient,
          search_employee: this.clients.searchEmployee
        }
  
        let sortColumn = ''
        let sortType = ''
        // let $dd = {}
        if (query) {
          sortColumn = query.sort.prop
          sortType = query.sort.order === 'descending' ? 'desc' : 'asc'
        } else {
          sortColumn = this.sortBy
          sortType = this.sortOrder
        }
  
        const sortOptions = {
          field: sortColumn,
          order: sortType
        }
        data = {
          ...data,
          ...sortOptions
        }
  
        this.loading = true
        const pageSize = query ? query.pageSize : 20
        const page = query ? query.page : 1
        this.apiRequest('/reports/ocr?page=' + page + '&pageSize=' + pageSize, 'GET', data, response => {
          if (response.status === true) {
            this.clientsTableData = response.data.data
            this.totalClients = response.data.total
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })
      },
      exportData () {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          start_date: this.clients.valid[0],
          end_date: this.clients.valid[1]
        }

        this.loading = true
        this.apiRequest('/reports/ocr-export', 'GET', data, response => {
          if (response.status === true) {
            const link = document.createElement('a')
            link.href = response.data.file
            link.setAttribute('download', response.data.file_name)
            document.body.appendChild(link)
            link.click()
          }
          this.loading = false
        })
      },
      requestReport () {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          start_date: this.clients.valid[0],
          end_date: this.clients.valid[1],
          type: 'exportRaportPuncte'
        }

        this.loading = true
        this.apiRequest('/reports/pending-report', 'POST', data, response => {
          if (response.status) {
            swal(
              {
                title: this.$t('reports.requestSuccess'),
                text: this.$t('reports.requestInfo'),
                type: 'success',
                showConfirmButton: true,
                confirmButtonText: this.$t('reports.requestConfirm')
              }
            )
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            )
          }
          this.loading = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Ocr.vue